import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Button, Flex, Img, Text, useStyleConfig} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink, safeBuildUrl} from '../../../../utils/contentstack-utils'
import SanitizedHtml from '../../../html-sanitizer'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useProducts} from '@salesforce/commerce-sdk-react'

export const ContentSliderTile = ({image = null, textblock = null, styleVariant}) => {
    const styles = useStyleConfig('ContentSlider', {variant: styleVariant})
    const damImage = useDamImage(image)
    const ctaColor = {
        base: styleVariant === 'grey' ? 'secondary' : 'inverse-primary',
        xl: 'inverse-primary',
    }
    const categoriesData = useGetCategoriesData()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids:
                    textblock?.button?.productsfcc?.data?.length > 0
                        ? textblock?.button.productsfcc.data[0].id
                        : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'content-slider-tile-index',
            },
        },
        {
            enabled: textblock?.button?.productsfcc?.data?.length > 0,
        },
    )
    const {buildUrl, locale} = useMultiSite()
    const {url, label, isAbsolute} = getGlobalLink({
        link: textblock?.button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(url, buildUrl),
          }

    return (
        <>
            <Box data-testid="content-slider-tile" {...styles.slidemain}>
                {damImage.url && (
                    <AspectRatio ratio={damImage.ratio} {...styles.image}>
                        <Img src={damImage.url} alt={image?.alt || ''} />
                    </AspectRatio>
                )}
                <Flex {...styles.textblock}>
                    <Flex {...styles.textblockheadingcontainer}>
                        {textblock?.label_paragraph && (
                            <Text {...styles.label_paragraph}>{textblock?.label_paragraph}</Text>
                        )}
                        {textblock?.title && (
                            <Text {...styles.textblocktitle}>{textblock?.title}</Text>
                        )}
                    </Flex>
                    {textblock?.body_copy && (
                        <SanitizedHtml
                            as={Box}
                            html={textblock?.body_copy}
                            {...styles.textblockbodycopy}
                        />
                    )}
                    {label && url && (
                        <Button {...buttonProps} {...styles.cta} variant={ctaColor}>
                            {label}
                        </Button>
                    )}
                </Flex>
            </Box>
        </>
    )
}

ContentSliderTile.propTypes = {
    image: PropTypes.shape(),
    textblock: PropTypes.shape({
        label: PropTypes.string,
        label_paragraph: PropTypes.string,
        title: PropTypes.string,
        body_copy: PropTypes.string,
        button: PropTypes.shape(),
    }),
    styleVariant: PropTypes.string,
}
